import React from 'react';
import PropTypes from 'prop-types';

// styles
import styles from '../PdpSharedDetails/PdpSharedDetail.scss';

function PdpRespDetail({ title, children }) {
    if (title && children) {
        return (
            <li className={styles.wrapper}>
                <div className={styles.title}>{title}</div>
                <div className={styles.content}>{children}</div>
            </li>
        );
    }
}

PdpRespDetail.propTypes = {
    title: PropTypes.node.isRequired,
    children: PropTypes.node.isRequired,
};

export default PdpRespDetail;
